import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Validation schema
const validationSchema = Yup.object().shape({
  period: Yup.string().required("Period is required"),
  loadFactor: Yup.number()
    .required("Load Factor is required")
    .typeError("Load Factor must be a number"),
});

export default function PeriodPricingForm({refetchProductDetails}) {
  const [loadFactorValue, setLoadFactorValue] = useState("");

  const initialValues = {
    period: "",
    loadFactor: "",
  };

  const periodOptions = [
    { value: "4days", label: "4 Days" },
    { value: "30days", label: "30 Days" },
    { value: "60days", label: "60 Days" },
  ];

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setTimeout(() => {
      alert("Period Pricing saved! (UI only)");
      setSubmitting(false);
      resetForm();
      setLoadFactorValue("");
    }, 500);

    refetchProductDetails?.()
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm my-4">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className="mb-3">
            <div className="row g-3">
              {/* Period Select */}
              <div className="col-md-6">
                <label htmlFor="period" className="form-label fw-semibold">
                  Period
                </label>
                <Field
                  as="select"
                  name="period"
                  className="form-select form-control"
                >
                  <option value="">Select Period</option>
                  {periodOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="period"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>

              {/* Load Factor Input */}
              <div className="col-md-6">
                <label htmlFor="loadFactor" className="form-label fw-semibold">
                  Load Factor
                </label>
                <Field
                  name="loadFactor"
                  type="number"
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue("loadFactor", value);
                    setLoadFactorValue(value);
                  }}
                />
                <ErrorMessage
                  name="loadFactor"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
            </div>

            {/* Day Buttons using loadFactor value */}
            <div
              className="day-button-group"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              {periodOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className="day-btn"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "12px 16px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                  }}
                >
                  <span>{option.label}</span>
                  <span style={{ fontSize: "12px", color: "#555" }}>
                    {loadFactorValue || 0}
                  </span>
                </button>
              ))}
            </div>

            {/* Save Button */}
            <div className="d-flex justify-content-end mt-4" style={{ gap: "24px" }}>
              <button
                type="submit"
                className="btn btn-success px-4 py-2"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save Period Pricing"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
